import { render } from "./arki-project-component.vue?vue&type=template&id=75a81958&scoped=true"
import script from "./arki-project-component.vue?vue&type=script&setup=true&lang=js"
export * from "./arki-project-component.vue?vue&type=script&setup=true&lang=js"

import "./arki-project-component.vue?vue&type=style&index=0&id=75a81958&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75a81958"],['__file',"src/views/arki/views/request/project/arki-project-component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "75a81958"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('75a81958', __exports__)) {
    api.reload('75a81958', __exports__)
  }
  
  module.hot.accept("./arki-project-component.vue?vue&type=template&id=75a81958&scoped=true", () => {
    api.rerender('75a81958', render)
  })

}


export default __exports__